import React from 'react';
import { st, classes } from './SocialPostPreview.st.css';
import { SocialPostPreviewProps } from './SocialPostPreview.types';
import { FacebookPost, InstagramPost } from './components';

const skinToPostComponentMap = {
  facebook: FacebookPost,
  instagram: InstagramPost,
} as const;

/** SocialPostPreview */
const SocialPostPreview = ({
  skin = 'facebook',
  className,
  dataHook,
  caption,
  media,
  profileName,
  profileImageSrc,
}: SocialPostPreviewProps) => {
  const PostComponent = skinToPostComponentMap[skin!];

  return (
    <div
      aria-hidden="true"
      data-hook={dataHook}
      data-skin={skin}
      data-profile={profileImageSrc}
      className={st(classes.root, {}, className)}
    >
      <PostComponent {...{ profileName, profileImageSrc, caption, media }} />
    </div>
  );
};

SocialPostPreview.displayName = 'SocialPostPreview';

export { SocialPostPreview };
